import React from 'react';
import { useSelector } from 'react-redux';
import { isCustomerServiceRoleSelector, isCDNAccountSelector } from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';

// extend to add additional role checks in future
function useCanAccessFeature({ feature = '' }) {
  const isCustomerServiceRole = useSelector(isCustomerServiceRoleSelector);
  const isCDNAccount = useSelector(isCDNAccountSelector);

  if (
    isCustomerServiceRole &&
    ![featureNames.VIEWER_MODULE_PULSE5, featureNames.VIEWER_DRILLDOWN_TIMELINE].includes(feature)
  ) {
    return false;
  }

  if (
    isCDNAccount &&
    [
      featureNames.VIEWER_MODULE_PULSE5,
      featureNames.VIEWER_DRILLDOWN_TIMELINE,
      featureNames.EXPERIENCE_DASHBOARD,
    ].includes(feature)
  ) {
    return false;
  }

  return true;
}

export default useCanAccessFeature;
